import { useSuspenseQuery } from '@tanstack/react-query'

import { simulacaoKeys } from '@/features/simulador/brasil/utils/queries'
import { GetSimulacoesPorIds } from '@/features/simulador/shared/http/get-simulacoes-por-ids.service'

export const useSuspenseSimulacoesPorIds = (simulacoesIds: string[]) => {
  return useSuspenseQuery({
    queryKey: simulacaoKeys.listaSimulacoesLancadas(simulacoesIds),
    queryFn: async () => new GetSimulacoesPorIds().execute(simulacoesIds).then((res) => res.data),
  })
}
